import moment from 'moment-timezone'

function validateArrival (stoppages, i, currentArrival, isValid, task) {
  let errorMessage = ''

  const arrivalMoment = moment(currentArrival).tz('Europe/Warsaw')
  const departureMoment = moment(stoppages[i].departure).tz('Europe/Warsaw')

  if (departureMoment.isBefore(arrivalMoment)) {
    isValid = false
    errorMessage = 'Zmiana godzin niemożliwa z uwagi na godzinę wyjazdu lub godzinę kolejnego punktu'
  }

  return { isValid: isValid, message: errorMessage }
}

function validateDeparture (stoppages, i, currentDeparture, isValid, task) {
  let errorMessage = ''

  const arrivalMoment = moment(stoppages[i].arrival).tz('Europe/Warsaw')
  const departureMoment = moment(currentDeparture).tz('Europe/Warsaw')

  if (departureMoment.isBefore(arrivalMoment)) {
    isValid = false
  }

  if (departureMoment.isBefore(arrivalMoment)) {
    isValid = false
    errorMessage = 'Zmiana godzin niemożliwa z uwagi na godzinę wyjazdu lub godzinę kolejnego punktu'
  }

  return { isValid: isValid, message: errorMessage }
}

export { validateArrival, validateDeparture }
